import { PasswordPolicy } from "@/api/openapi";
import PspTextInput from "@/components/pspTextInput/pspTextInput";
import { PasswordPolicyError } from "@/config/types";
import { Dispatch, SetStateAction } from "react";
import { useChangePasswordForm } from "./changePasswordForm/useChangePasswordForm";
// eslint-disable-next-line max-len
import { PasswordRequirementsList } from "@/components/passwordRequirementsList/passwordRequirementsList";

export declare type ChangePasswordFormProps = {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  wrongPassword: boolean;
  passwordsDontMatch: boolean;
  setOldPassword: (oldPassword: string) => void;
  setNewPassword: (newPassword: string) => void;
  setConfirmNewPassword: (confirmNewPassword: string) => void;
  setWrongPassword: (wrongPassword: boolean) => void;
  passwordPolicy: PasswordPolicy;
  passwordRequirements: Record<PasswordPolicyError, boolean>;
  setPasswordRequirements: Dispatch<
    SetStateAction<Record<PasswordPolicyError, boolean>>
  >;
};

export default function ChangePasswordForm({
  confirmNewPassword,
  newPassword,
  oldPassword,
  wrongPassword,
  setConfirmNewPassword,
  setNewPassword,
  setOldPassword,
  setWrongPassword,
  passwordsDontMatch,
  passwordRequirements,
  setPasswordRequirements,
  passwordPolicy,
}: ChangePasswordFormProps) {
  const { onChangeNewPassword, onChangeOldPassword } = useChangePasswordForm({
    passwordPolicy,
    setNewPassword,
    setOldPassword,
    setPasswordRequirements,
    setWrongPassword,
  });

  return (
    <>
      <div className="flex flex-col gap-4 my-4">
        {/* OLD PASSWORD */}
        <div className="mb-8">
          <PspTextInput
            value={oldPassword}
            onChange={onChangeOldPassword}
            label="oldPassword"
            type="password"
            invalidDataMessage={wrongPassword ? "wrongPassword" : "empty"}
          />
        </div>

        {/* NEW PASSWORD */}
        <PspTextInput
          value={newPassword}
          onChange={onChangeNewPassword}
          label="newPassword"
          type="password"
          invalidDataMessage={
            passwordsDontMatch ? "passwordsDontMatch" : undefined
          }
        />

        {/* NEW PASSWORD CONFIRMATION */}
        <PspTextInput
          value={confirmNewPassword}
          onChange={setConfirmNewPassword}
          label="confirmNewPassword"
          type="password"
          invalidDataMessage={
            passwordsDontMatch ? "passwordsDontMatch" : undefined
          }
        />

        <PasswordRequirementsList
          passwordsDontMatch={passwordsDontMatch}
          passwordRequirements={passwordRequirements}
        />
      </div>
    </>
  );
}
